// GENERATED-ADJACENT: pure quote engine shared by all QB modes.
// No DOM, no fetch, no privileged operations. Section aliases point here.
window.QBEngine = (function () {
  'use strict';
  const TAX = {
    AB:{gst:5,pst:0,label:"GST (5%)"},BC:{gst:5,pst:7,label:"GST+PST (12%)"},
    MB:{gst:5,pst:7,label:"GST+RST (12%)"},NB:{gst:15,pst:0,label:"HST (15%)"},
    NL:{gst:15,pst:0,label:"HST (15%)"},NS:{gst:14,pst:0,label:"HST (14%)"},
    NT:{gst:5,pst:0,label:"GST (5%)"},NU:{gst:5,pst:0,label:"GST (5%)"},
    ON:{gst:13,pst:0,label:"HST (13%)"},PE:{gst:15,pst:0,label:"HST (15%)"},
    QC:{gst:5,pst:9.975,label:"GST+QST (14.975%)"},SK:{gst:5,pst:6,label:"GST+PST (11%)"},
    YT:{gst:5,pst:0,label:"GST (5%)"}
  };
  const toM2 = (val, unit) => unit === 'ft2' ? val / 10.764 : val;
  const toFt2 = (val) => val * 10.764;
  const fmt = v => '$' + v.toLocaleString('en-CA', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  function getPrice(shopifyProduct) {
    if (!shopifyProduct || !shopifyProduct.variants) return 0;
    const v = shopifyProduct.variants.find(v => v.available) || shopifyProduct.variants[0];
    return v ? v.price / 100 : 0;
  }
  function getVariantId(shopifyProduct) {
    if (!shopifyProduct || !shopifyProduct.variants) return null;
    const v = shopifyProduct.variants.find(v => v.available) || shopifyProduct.variants[0];
    return v ? v.id : null;
  }
  function getVariantTitle(shopifyProduct) {
    if (!shopifyProduct || !shopifyProduct.variants) return '';
    const v = shopifyProduct.variants.find(v => v.available) || shopifyProduct.variants[0];
    return (v && v.title !== 'Default Title') ? v.title : '';
  }
  function parseVariantSize(title) {
    if (!title) return null;
    // Match number at start of string (handles "5 kg", "3.12kg", ".6 kg", "6.25kg", etc.)
    const match = title.match(/^\.?\d+\.?\d*/);
    if (match) {
      return parseFloat(match[0]);
    }
    return null;
  }
  function extractSizeString(title) {
    if (!title || title === 'Default Title') return '';
    // Match number + unit (handles "5 kg", "3.12kg", ".6kg", "6.25kg", etc.)
    const match = title.match(/(\.?\d+\.?\d*)\s*(kg|g|l|ml)/i);
    if (match) {
      const num = parseFloat(match[1]);
      return num + match[2].toLowerCase();
    }
    return '';
  }
  function findOptimalVariants(variants, amountNeeded) {
    if (!variants || variants.length === 0) return [];

    // Parse, filter to variants that have a readable size, sort largest → smallest
    const parsed = variants
      .map(v => ({
        id: v.id,
        title: v.title,
        // Carried, not dropped: canon pins some SKUs at retail, and a caller
        // that never sees the SKU cannot honour that (2026-09-09).
        sku: v.sku || '',
        size: parseVariantSize(v.title) || parseVariantSize(v.option1),
        price: v.price / 100,
        available: v.available !== false
      }))
      .filter(v => v.size !== null && v.size > 0 && v.available)
      .sort((a, b) => b.size - a.size); // largest first for greedy loop

    if (parsed.length === 0) return [];

    // Deduplicate by size — keep cheapest variant per size
    const bySize = new Map();
    parsed.forEach(v => {
      const existing = bySize.get(v.size);
      if (!existing || v.price < existing.price) bySize.set(v.size, v);
    });
    const variants2 = Array.from(bySize.values()).sort((a, b) => b.size - a.size);

    let bestCost = Infinity;
    let bestWaste = Infinity;
    let bestCombination = null;

    const updateBest = (combo) => {
      let cost = 0, total = 0;
      combo.forEach(c => { cost += c.quantity * c.price; total += c.quantity * c.size; });
      const waste = total - amountNeeded;
      if (waste < -0.0001) return; // doesn't actually cover the amount — skip
      if (cost < bestCost || (Math.abs(cost - bestCost) < 0.001 && waste < bestWaste)) {
        bestCost = cost;
        bestWaste = waste;
        bestCombination = combo.filter(c => c.quantity > 0).map(c => ({ ...c }));
      }
    };

    // For products with only one size, answer is trivial
    if (variants2.length === 1) {
      const v = variants2[0];
      const qty = Math.ceil(amountNeeded / v.size);
      return [{ ...v, quantity: qty }];
    }

    // Exhaustive search: for 2 or 3 distinct sizes, iterate quantities of the two
    // larger sizes and fill the remainder with the smallest.
    // Cap iterations: max units of any given size is ceil(amountNeeded / size) + 1
    // This is O(N²) in the worst case but N is always tiny (2–4 sizes per product).
    const smallest = variants2[variants2.length - 1];

    // Try every combo of the non-smallest sizes
    const larger = variants2.slice(0, -1); // everything except smallest

    // Recursive helper: enumerate qty combos for `larger` variants starting at index `idx`
    // carrying a running `covered` total and `currentCombo` array
    function search(idx, covered, currentCombo) {
      if (idx === larger.length) {
        // All larger sizes assigned — fill remainder with smallest
        const remaining = amountNeeded - covered;
        const qSmall = remaining > 0 ? Math.ceil(remaining / smallest.size) : 0;
        const combo = [...currentCombo, { ...smallest, quantity: qSmall }];
        updateBest(combo);
        return;
      }

      const v = larger[idx];
      const maxQty = Math.ceil(amountNeeded / v.size) + 1; // never need more than this

      for (let q = 0; q <= maxQty; q++) {
        // Early-exit: if cost of current path already exceeds best, prune
        const partialCost = currentCombo.reduce((s, c) => s + c.quantity * c.price, 0) + q * v.price;
        if (partialCost > bestCost + 0.001) break;

        search(idx + 1, covered + q * v.size, [...currentCombo, { ...v, quantity: q }]);
      }
    }

    search(0, 0, []);

    // Fallback: should never be needed, but just in case
    if (!bestCombination) {
      const v = variants2[0]; // largest
      bestCombination = [{ ...v, quantity: Math.ceil(amountNeeded / v.size) }];
    }

    return bestCombination;
  }
  function encodeQuoteData(data) {
    try {
      const json = JSON.stringify(data);
      return btoa(encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode('0x' + p1)));
    } catch (e) {
      console.error('[Quote Builder] Encode error:', e);
      return null;
    }
  }
  function decodeQuoteData(encoded) {
    try {
      const json = decodeURIComponent(atob(encoded).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
      return JSON.parse(json);
    } catch (e) {
      console.error('[Quote Builder] Decode error:', e);
      return null;
    }
  }
  function slugify(str) {
    return str.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // HTML escaper - every decoded/user-supplied string rendered into the page
  // goes through this (X1 fix groundwork).
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  // Clamps a decoded share payload to sane bounds (X3 fix groundwork).
  function clampQuote(q, maxDiscountPct) {
    if (!q || typeof q !== 'object') return q;
    var maxD = typeof maxDiscountPct === 'number' ? maxDiscountPct : 30;
    var d = parseFloat(q.d); q.d = isFinite(d) ? Math.min(Math.max(d, 0), maxD) : 0;
    var cap = function (s, n) { return String(s == null ? '' : s).slice(0, n); };
    q.c = cap(q.c, 120); q.co = cap(q.co, 120); q.e = cap(q.e, 254);
    q.ph = cap(q.ph, 40); q.a = cap(q.a, 300); q.cl = cap(q.cl, 120);
    q.n = cap(q.n, 40); q.m = cap(q.m, 2000);
    if (Array.isArray(q.addons)) {
      q.addons = q.addons.slice(0, 20).map(function (a) {
        return { desc: cap(a.desc, 200), qty: Math.min(Math.max(parseFloat(a.qty) || 0, 0), 999),
                 price: Math.min(Math.max(parseFloat(a.price) || 0, 0), 100000), disc: !!a.disc };
      });
    }
    return q;
  }

  // Substrate label -> product-route key. Port of the Atlas worker's
  // resolveSubstrateKey (index.js): handleize, exact hit, then token-subset
  // match either direction, else 'default'.
  function handleizeKey(s) {
    return String(s || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function resolveSubstrateKey(routes, substrate) {
    if (!routes) return 'default';
    const h = handleizeKey(substrate);
    if (routes[h]) return h;
    const tokens = h.split('-').filter(Boolean);
    for (const key of Object.keys(routes)) {
      if (key === 'default') continue;
      const kt = key.split('-').filter(Boolean);
      if (kt.every(function (x) { return tokens.indexOf(x) !== -1; }) ||
          (tokens.length > 0 && tokens.every(function (x) { return kt.indexOf(x) !== -1; }))) return key;
    }
    return 'default';
  }

  // Pure per-step pipeline computation, shared by the rep System Builder and
  // the customer Guided Builder so a system quote is identical whoever builds
  // it (one price truth). Faithful port of the rep tool's inline math.
  //   step: { handle, coats, watstopMode, qtyOverride, product }
  //   rate: the PRODUCT_RATES entry for the handle (may be undefined)
  //   opts: { areaM2, wasteFactor, thicknessMm, unit:'m2'|'ft2', priceFactor }
  // priceFactor scales the resulting prices uniformly (rep=1; customer passes
  // its tier factor - 1 for catalog tiers whose variant prices are already
  // contextual, 0.80 for Elite over retail). Uniform scaling leaves the
  // cost-optimal variant selection unchanged, so the pick never shifts.
  function computePipelineStep(step, rate, opts) {
    opts = opts || {};
    const area = Number(opts.areaM2) || 0;
    const wasteFactor = Number(opts.wasteFactor) || 1.10;
    const thickness = Number(opts.thicknessMm) || 0;
    const unit = opts.unit === 'ft2' ? 'ft2' : 'm2';
    const priceFactor = typeof opts.priceFactor === 'number' ? opts.priceFactor : 1;
    // No-discount SKUs (samples) are pinned at retail by canon, so the tier
    // factor stops at them. The Quick tab has always done this (price$); the
    // guided path multiplied everything and quoted a contractor a discount the
    // catalogue will not honour (2026-09-09).
    const pinned = new Set(opts.noDiscountSkus || []);
    const factorFor = sku => (sku && pinned.has(sku) ? 1 : priceFactor);
    const prod = step.product;
    const productRate = rate;

    const out = { rate: 0, rateDisplay: '', needsThickness: false, materialNeeded: 0,
      isLinearCalc: false, isRollCalc: false, optimalSelection: [], totalUnits: 0,
      totalPrice: 0, selectionDisplay: '', calcText: '', linearUnit: 'm', coveragePerUnit: null };
    if (!prod) return out;

    let rateVal = 0, rateDisplay = '', needsThickness = false, materialNeeded = 0;
    let isLinearCalc = false, isRollCalc = false;

    if (productRate) {
      if (productRate.isLinear) {
        isLinearCalc = true;
        if (unit === 'ft2') {
          const areaFt2 = area * 10.764;
          const perimeterFt = 4 * Math.sqrt(areaFt2);
          const seamsFt = areaFt2 * 0.25;
          materialNeeded = Math.ceil(perimeterFt + seamsFt);
          out.linearUnit = 'ft';
          out.coveragePerUnit = productRate.coveragePerUnitM * 3.28084;
          rateDisplay = Math.round(perimeterFt) + 'ft perim + ' + Math.round(seamsFt) + 'ft seams';
        } else {
          const perimeter = 4 * Math.sqrt(area);
          const seams = area * (productRate.seamFactorMetric || 0.82);
          materialNeeded = perimeter + seams;
          out.linearUnit = 'm';
          out.coveragePerUnit = productRate.coveragePerUnitM || 10;
          rateDisplay = Math.round(perimeter) + 'm perim + ' + Math.round(seams) + 'm seams';
        }
      } else if (productRate.isRoll) {
        materialNeeded = area * (productRate.overlapFactor || 1.10) * wasteFactor;
        isRollCalc = true;
        rateDisplay = (productRate.overlapFactor || 1.10) + ' m²/m² (overlap)';
      } else if (productRate.isDiathonite) {
        if (thickness > 0) {
          rateVal = productRate.yieldPer10mm * (thickness / 10);
          rateDisplay = productRate.yieldPer10mm + ' kg/m²/10mm × ' + thickness + 'mm';
        } else {
          needsThickness = true; rateVal = 0;
          rateDisplay = '<span style="color:#c41e3a">⚠ Set thickness</span>';
        }
      } else {
        let coats = step.coats;
        let perCoat = productRate.yieldKgM2;
        if (productRate.hasMode && productRate.modes && step.watstopMode) {
          const sm = productRate.modes[step.watstopMode];
          if (sm) { coats = sm.coats; if (sm.yieldKgM2) perCoat = sm.yieldKgM2; }
        }
        rateVal = perCoat * coats;
        rateDisplay = perCoat + ' kg/m² × ' + coats + ' coat' + (coats > 1 ? 's' : '');
      }
    } else {
      rateVal = step.coats * 1.0;
      rateDisplay = step.coats + ' coat' + (step.coats > 1 ? 's' : '');
    }

    if (!isLinearCalc && !isRollCalc) {
      // Waste applies to every product, sealers and liquids included
      // (J. Nelson 2026-09-07: "if a customer chooses 10% it's on everything").
      // The old noWaste carve-out for D20/Aquafloor/etc. is retired.
      materialNeeded = area * rateVal * wasteFactor;
    }

    const variants = prod.variants || [];
    let optimalSelection, totalUnits = 0, totalPrice = 0, selectionDisplay = '';

    if ((isLinearCalc || isRollCalc) && !step.qtyOverride) {
      const coverage = isLinearCalc ? (out.coveragePerUnit || (productRate.coveragePerUnitM || 10)) : (productRate.rollCoverageM2 || 50);
      totalUnits = Math.ceil(materialNeeded / coverage);
      const unitLabel = isLinearCalc ? (productRate.unitLabel || 'roll') : 'roll';
      const defaultVariant = variants.find(v => v.available !== false) || variants[0];
      if (defaultVariant) {
        const p = (defaultVariant.price / 100) * factorFor(defaultVariant.sku);
        totalPrice = totalUnits * p;
        optimalSelection = [{ id: defaultVariant.id, title: defaultVariant.title, sku: defaultVariant.sku || '',
          size: coverage, price: p, quantity: totalUnits }];
      } else {
        optimalSelection = [];
      }
      selectionDisplay = totalUnits + ' ' + unitLabel + (totalUnits !== 1 ? 's' : '');
    } else {
      optimalSelection = findOptimalVariants(variants, materialNeeded).map(s => ({ ...s, price: s.price * factorFor(s.sku) }));
    }

    if ((isLinearCalc || isRollCalc) && step.qtyOverride && optimalSelection.length > 0) {
      totalUnits = step.qtyOverride;
      totalPrice = totalUnits * optimalSelection[0].price;
      const overrideLabel = isLinearCalc ? (productRate.unitLabel || 'roll') : 'roll';
      selectionDisplay = totalUnits + ' ' + overrideLabel + (totalUnits !== 1 ? 's' : '');
      optimalSelection = [{ ...optimalSelection[0], quantity: totalUnits }];
    }

    if (!isLinearCalc && !isRollCalc) {
      totalUnits = 0; totalPrice = 0; selectionDisplay = '';
      if (step.qtyOverride && optimalSelection.length > 0) {
        const largest = optimalSelection.reduce((a, b) => (a.size > b.size ? a : b), optimalSelection[0]);
        totalUnits = step.qtyOverride;
        totalPrice = totalUnits * largest.price;
        selectionDisplay = totalUnits + '× ' + extractSizeString(largest.title);
        optimalSelection = [{ ...largest, quantity: totalUnits }];
      } else if (optimalSelection.length > 0) {
        optimalSelection.forEach(sel => { totalUnits += sel.quantity; totalPrice += sel.quantity * sel.price; });
        selectionDisplay = optimalSelection.map(sel => sel.quantity + '× ' + extractSizeString(sel.title)).join(' + ');
      } else if (productRate && productRate.pack_kg > 0 && variants.length) {
        // A product whose variant title carries no size (a Default Title bag
        // such as the 18 kg Ardex X5) sells by the canon pack: whole bags of
        // pack_kg, the way the Quick card counts it. Review 2026-09-07: the
        // fallback below priced it per kilogram and returned no selection, so
        // it never reached the cart.
        const bag = variants.find(v => v.available !== false) || variants[0];
        const bagPrice = (bag.price / 100) * priceFactor;
        totalUnits = step.qtyOverride ? step.qtyOverride : Math.max(1, Math.ceil(materialNeeded / productRate.pack_kg));
        totalPrice = totalUnits * bagPrice;
        selectionDisplay = totalUnits + '× ' + productRate.pack_kg + 'kg';
        optimalSelection = [{ id: bag.id, title: bag.title, size: productRate.pack_kg, price: bagPrice, quantity: totalUnits }];
      } else {
        const fallbackPrice = (((variants[0] && variants[0].price) || 0) / 100) * priceFactor;
        totalUnits = Math.ceil(materialNeeded);
        totalPrice = totalUnits * fallbackPrice;
        selectionDisplay = totalUnits + ' units';
      }
    }

    const wastePercent = Math.round((wasteFactor - 1) * 100);
    let calcText;
    // The leading area prints in the unit the caller asks for through
    // opts.areaDisplayUnit ('ft2' from the trade customer in imperial mode);
    // the rate stays per m². Without that option the text is exactly the rep
    // tool's (linear steps follow the calc unit, everything else prints m²),
    // so parity.js stays byte-identical for the System Builder.
    const showFt = isLinearCalc ? out.linearUnit === 'ft' : opts.areaDisplayUnit === 'ft2';
    const areaDisplay = showFt ? (area * 10.764).toFixed(0) + ' ft²' : area.toFixed(1) + ' m²';
    if (isLinearCalc) {
      calcText = areaDisplay + ' → ' + rateDisplay + ' = ' + Math.round(materialNeeded) + out.linearUnit + ' → ' + selectionDisplay;
    } else if (isRollCalc) {
      calcText = areaDisplay + ' × ' + rateDisplay + ' + ' + wastePercent + '% = ' + materialNeeded.toFixed(1) + 'm² → ' + selectionDisplay;
    } else {
      calcText = areaDisplay + ' × ' + rateDisplay + ' + ' + wastePercent + '% = ' + materialNeeded.toFixed(1) + 'kg → ' + selectionDisplay;
    }

    out.rate = rateVal; out.rateDisplay = rateDisplay; out.needsThickness = needsThickness;
    out.materialNeeded = materialNeeded; out.isLinearCalc = isLinearCalc; out.isRollCalc = isRollCalc;
    out.optimalSelection = optimalSelection; out.totalUnits = totalUnits; out.totalPrice = totalPrice;
    out.selectionDisplay = selectionDisplay; out.calcText = calcText;
    return out;
  }

  // ---- Guided system lines (customer Guided Builder), pure ------------------
  // One entry per pipeline step from the state alone (Phase 1.3): nothing is
  // painted and the steps are not written to, so the lines a system produces
  // never depend on having rendered it. The renderer maps these to HTML; the
  // add-to-quote, the guide link and the quantity steppers read the same array.
  //   steps: [{ sid, handle, product, coats, watstopMode, qtyOverride, enabled,
  //             isPrep, optional, suggestion, label, role, linearLen }]
  //   opts:  { areaM2, wasteFactor, thicknessMm, unit, priceFactor, rates,
  //            color, customFeePrice, colorProducts }
  // A linear prep step with linearLen null takes the perimeter + seams estimate
  // for the current area (it follows the area until the contractor types a
  // length); a typed length sticks. Returns { lines, total }.
  function guidedLines(steps, opts) {
    opts = opts || {};
    const area = Number(opts.areaM2) || 0;
    const rates = opts.rates || {};
    const out = { lines: [], total: 0, areaM2: area };
    if (!(area > 0)) return out;
    (steps || []).forEach(function (step) {
      if (!step.product) return;
      const rate = rates[step.handle];
      const so = { areaM2: area, wasteFactor: opts.wasteFactor, thicknessMm: opts.thicknessMm, unit: opts.unit,
        priceFactor: opts.priceFactor, noDiscountSkus: opts.noDiscountSkus, areaDisplayUnit: opts.unit };
      const line = { sid: step.sid, handle: step.handle, name: step.isPrep ? step.label : step.product.title,
        isPrep: !!step.isPrep, optional: !!step.optional, enabled: step.enabled !== false, role: step.role || '',
        linear: null, calcText: '', totalUnits: 0, totalPrice: 0, eachPrice: null, selection: [] };
      if (step.isPrep && step.suggestion === 'linear') {
        const est = computePipelineStep(step, rate, so);
        const coverage = est.coveragePerUnit || 1;
        const unit = est.linearUnit || 'm';
        const each = est.optimalSelection.length ? est.optimalSelection[0].price : 0;
        const len = (step.linearLen != null) ? step.linearLen : Math.max(1, Math.ceil(est.materialNeeded));
        const units = Math.max(1, Math.ceil(len / coverage));
        const unitLabel = (rate && rate.unitLabel) || 'unit';
        line.linear = { unit: unit, len: len, estimate: step.linearLen == null };
        line.selection = est.optimalSelection.length ? [Object.assign({}, est.optimalSelection[0], { quantity: units })] : [];
        line.totalUnits = units; line.totalPrice = units * each; line.eachPrice = each;
        line.selectionText = units + ' ' + unitLabel + (units !== 1 ? 's' : '');
        line.calcText = units + ' ' + unitLabel + (units !== 1 ? 's' : '') + ' for ' + len + ' ' + unit;
      } else {
        const r = computePipelineStep(step, rate, so);
        line.selection = r.optimalSelection; line.totalUnits = r.totalUnits; line.totalPrice = r.totalPrice;
        line.calcText = r.calcText; line.selectionText = r.selectionDisplay;
        line.eachPrice = r.optimalSelection.length === 1 ? r.optimalSelection[0].price : null;
      }
      if (line.enabled) out.total += line.totalPrice;
      out.lines.push(line);
    });
    return out;
  }

  // ---- Quote totals, pure: ONE arithmetic for every panel ---------------------
  // The old rep tool computed its totals twice, once for the rep's panel and
  // again when rendering the customer's copy, with a comment saying the second
  // "mirrors" the first. Two implementations of one sum is how a rep quotes one
  // number and a customer reads another. There is one here, and the customer
  // panel's quoteTotals is a call to it (Trade Desk plan, Step 0).
  //
  //   cart:     [{ price, qty, color }]   products; always discountable, always taxed
  //   services: [{ price, qty, discountable, taxable }]   Adin's Additional Services
  //   pct:      the rep's discount, 0 for a customer quote
  //   province: a TAX key
  // Services are taxable unless a line says otherwise (J. Nelson 2026-09-08:
  // freight and site visits are taxable in Saskatchewan and the wrong default
  // puts a tax error on a real invoice).
  // ---------------------------------------------------------------- images
  // A product photo at the width the card shows, so a 98 KB original is not
  // downloaded to fill a 160 px box (measured against the live CDN 2026-09-10:
  // 98 KB original, 7.8 KB at width=160, 20 KB at width=320).
  //
  // Shopify hands these over protocol-relative and in two shapes, the shared
  // cdn.shopify.com host and the store's own /cdn/shop/ path. Both accept a
  // width parameter. Anything else is handed back untouched: a foreign URL is
  // not ours to rewrite.
  function imageUrl(src, width) {
    let u = String(src == null ? '' : src).trim();
    if (!u) return '';
    if (u.slice(0, 2) === '//') u = 'https:' + u;
    const w = Math.round(Number(width) || 0);
    if (!(w > 0)) return u;
    const shopify = /^https?:\/\/cdn\.shopify\.com\//i.test(u) || u.indexOf('/cdn/shop/') !== -1;
    if (!shopify) return u;
    // Hand-built rather than via URL(): searchParams re-encodes the existing
    // ?v= cache key, and a changed key is a changed URL to every cache.
    if (/[?&]width=/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=' + w);
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // What a card needs: one src at the size it shows, and a 2x for a retina
  // screen. Returned as a pair so the caller decides the markup.
  function imageSet(src, width) {
    const one = imageUrl(src, width);
    if (!one) return null;
    const two = imageUrl(src, width * 2);
    return { src: one, srcset: one + ' 1x' + (two && two !== one ? ', ' + two + ' 2x' : '') };
  }

  // ---------------------------------------------------------------- rep inputs
  // THE WORKER'S OWN SANITISING, restated once so the panel cannot price a value
  // the record will never hold. Every clamp here has a twin in
  // qb-worker/src/rep.js (validateSave, then saveQuote), and money.test.js
  // fuzzes the pair to prove they still agree.
  //
  // Before this existed, each side sanitised by hand and they drifted. All three
  // were live and silent (found 2026-09-09): a custom-priced SKU was discounted
  // on screen and pinned at retail in the record ($337 on a two-line quote); a
  // service quantity of 12.5 was priced on screen and floored in the record; a
  // negative service price showed as a credit on screen and became zero in the
  // record. In every case the rep read one total and the customer was invoiced
  // another, which is the one thing this tool exists not to do.
  function repService(s) {
    s = s || {};
    return {
      label: String(s.label == null ? '' : s.label).slice(0, 120),
      price: Math.min(Math.max(Number(s.price) || 0, 0), 100000),
      qty: Math.min(Math.max(parseInt(s.qty, 10) || 1, 1), 999),
      taxable: s.taxable !== false,
      discountable: s.discountable !== false,
    };
  }
  //   cart:                the panel's lines, as pushCartLine built them
  //   opts.noDiscountSkus: canon's no-discount SKUs (DATA.noDiscountSkus)
  function repInputs(cart, services, opts) {
    opts = opts || {};
    const pinned = new Set(opts.noDiscountSkus || []);
    return {
      lines: (cart || []).map(function (l) { return Object.assign({}, l, { noDiscount: !!(l.sku && pinned.has(l.sku)) }); }),
      services: (services || []).map(repService),
    };
  }

  function repTotals(cart, services, pct, province) {
    const lines = cart || [];
    const rate = (Number(pct) || 0) / 100;
    // Shopify's rule, measured against a real draft order: a percentage
    // discount is worked out per LINE, on the line total, and TRUNCATED to the
    // cent. Matching it here is what makes the number a customer accepts the
    // number they are invoiced (2026-09-08).
    const lineDiscount = (t2) => Math.floor((t2 * rate + 1e-9) * 100) / 100;
    // `+ 0` normalises negative zero; see money.js in the worker.
    const R0 = n => Math.round(n * 100) / 100 + 0;
    // And the same for tax, measured against real drafts #D201 and #D202
    // (2026-09-09): Shopify works it out PER LINE and PER RATE, rounds each one
    // HALF UP to the cent, and sums those. GST and PST are two tax lines, never
    // one combined percentage. Taxing a summed base once gives a different
    // answer, and Shopify's is the one on the invoice.
    const tax = TAX[province] || TAX.SK;
    const taxOn = function (base, ratePct) {
      if (!(ratePct > 0) || !(base > 0)) return 0;
      return Math.round(Math.round(base * 100) * ratePct / 100 + 1e-9) / 100;
    };
    const lineTax = function (base) { return taxOn(base, tax.gst) + taxOn(base, tax.pst); };
    let count = 0, sub = 0, discSub = 0, lineDisc = 0, taxAcc = 0;
    // Mirrors quoteMoney's `parts`: what each line is worth before and after
    // its own discount, so the panel and the customer's page can show the
    // saving per item without either of them doing arithmetic.
    const parts = [], svcParts = [];
    lines.forEach(function (c) {
      const q = Number(c.qty) || 0;
      const amt = (Number(c.price) || 0) * q;
      count += q; sub += amt;
      // A custom-priced SKU is pinned at retail by canon and takes no tier
      // discount, on any path (review 2026-09-08: the rep path was giving it
      // one). The line says so; this function does not have to know which.
      let d = 0;
      if (!c.noDiscount) {
        discSub += amt;
        d = lineDiscount(amt);
        lineDisc += d;
      }
      taxAcc += lineTax(amt - d);                     // every product line is taxed
      // Same derivation as the worker's: the discounted unit comes from the
      // LINE total, half up, which is how Shopify shows it on the invoice.
      parts.push({ gross: R0(amt), disc: R0(d), net: R0(amt - d),
        unitGross: R0(Number(c.price) || 0),
        unitNet: q > 0 ? R0((amt - d) / q) : R0(amt - d) });
    });
    let serviceSub = 0, svcDiscountable = 0;
    (services || []).forEach(function (x) {
      const amt = (Number(x.price) || 0) * (Number(x.qty) || 1);
      const disc = x.discountable !== false;          // default: the discount applies
      const taxed = x.taxable !== false;              // default: taxable
      serviceSub += amt;
      let d = 0;
      if (disc) {
        svcDiscountable += amt;
        d = lineDiscount(amt);
        lineDisc += d;
      }
      if (taxed) taxAcc += lineTax(amt - d);
      svcParts.push({ gross: R0(amt), disc: R0(d), net: R0(amt - d),
        unitGross: R0(Number(x.price) || 0),
        unitNet: (Number(x.qty) || 1) > 0 ? R0((amt - d) / (Number(x.qty) || 1)) : R0(amt - d) });
    });
    const discountBase = discSub + svcDiscountable;
    const R = n => Math.round(n * 100) / 100 + 0;   // + 0: never -0, see money.js
    // Already at the cent, line by line, exactly as Shopify will charge it.
    const discountAmt = R(lineDisc);
    const taxAmt = R(taxAcc);
    return {
      count: count, sub: sub,
      serviceSub: serviceSub, discountBase: discountBase, discountAmt: discountAmt,
      parts: parts, svcParts: svcParts,
      // everything before tax, after the discount: exactly total - taxAmt
      netSub: R(sub + serviceSub - discountAmt),
      taxLabel: tax.label, taxAmt: taxAmt,
      total: R(R(sub) + R(serviceSub) - discountAmt + taxAmt),
    };
  }

  // The customer panel: no services, no discount. Written as the call rather
  // than as a copy, so the two can never disagree.
  function quoteTotals(cart, province) {
    return repTotals(cart, [], 0, province);
  }

  // ---- The order lines, pure: the ONE builder both checkout paths use -------
  // The cart path posts `items` to /cart/add.js; the Elite path sends the same
  // lines to the quote service (UX plan 3.3), so a property written once rides
  // both ways. cart: the panel's lines; job: the job name. Returns { items }.
  function orderLines(cart, job) {
    const jobName = String(job || '').trim();
    const items = (cart || []).map(function (item) {
      const line = { id: item.variantId, quantity: item.qty };
      const props = Object.assign({}, item.properties || {});
      if (jobName) props['Job'] = jobName;
      if (item.note) props['Note'] = item.note;
      // Both keys: '_Installation Guide' is what the tool writes now (hidden
      // at checkout); a resumed older cart can still carry the plain key.
      if (props['_Installation Guide']) props['_Installation Guide'] = guideLinkWithJob(props['_Installation Guide'], jobName);
      if (props['Installation Guide']) props['Installation Guide'] = guideLinkWithJob(props['Installation Guide'], jobName);
      if (Object.keys(props).length) line.properties = props;
      return line;
    });
    return { items: items };
  }

  // The guide link a line carries takes the job as it stands at checkout (the
  // job is usually typed after the system was added). Hand-built: URLSearch-
  // Params writes a plus for a space, which the guide page leaves as a plus.
  function guideLinkWithJob(url, job) {
    const base = String(url || '').replace(/[?&]project_name=[^&#]*/g, '');
    if (!job) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'project_name=' + encodeURIComponent(job);
  }

  // The Elite send body (UX plan 3.3, contract v 1). Built from the state
  // alone; the service trusts none of the money in it (client is a drift
  // check).
  function quotePayload(cart, job, province, unit, key, client) {
    const built = orderLines(cart, job);
    return {
      v: 1,
      key: String(key || ''),
      job: String(job || '').trim(),
      province: province,
      unit: unit === 'm2' ? 'm2' : 'ft2',
      lines: built.items.map(function (line, i) {
        return { variant_id: line.id, qty: line.quantity, handle: (cart[i] && cart[i].handle) || '', properties: line.properties || {} };
      }),
      client: client || {},
    };
  }

  return { TAX: TAX, orderLines: orderLines, quotePayload: quotePayload, guideLinkWithJob: guideLinkWithJob, toM2: toM2, toFt2: toFt2, fmt: fmt, getPrice: getPrice, getVariantId: getVariantId, getVariantTitle: getVariantTitle, parseVariantSize: parseVariantSize, extractSizeString: extractSizeString, findOptimalVariants: findOptimalVariants, encodeQuoteData: encodeQuoteData, decodeQuoteData: decodeQuoteData, slugify: slugify, esc: esc, clampQuote: clampQuote, handleizeKey: handleizeKey, repInputs: repInputs, repService: repService,
    imageUrl: imageUrl, imageSet: imageSet, resolveSubstrateKey: resolveSubstrateKey, computePipelineStep: computePipelineStep, guidedLines: guidedLines, quoteTotals: quoteTotals, repTotals: repTotals };
})();
